import DialogHeader from './dialogHeader.container'

export default DialogHeader;